function getCartDefaultState() {
    return {
        loading: false,
        loadingError: false,
        cart: {
            productCount: 0,
            totalToPay: '',
            totalWithoutExpenses: '',
            totalShipping: 'checkout-cart-shipping-unknown',
            shippingTime: '',
            itemsQuantity: 4,
            products: [],
            contentTemplate: '',
            totalsTemplate: '',
            hasAnalytics: false,
            discountInfo: {
                type: '',
                name: '',
            },
        },
        checkout: {
            addressBilling: {
                billingFirstName: null,
                billingLastName: null,
                billingCompany: null,
                billingStreet: null,
                billingStreetNumber: null,
                billingCity: null,
                billingPostCode: null,
                billingCountry: null,
                billingTel: null,
                billingState: null,
                billingEmail: null,
                billingTitle: null
            },
            addressShipping: {
                shippingFirstName: null,
                shippingLastName: null,
                shippingCompany: null,
                shippingStreet: null,
                shippingStreetNumber: null,
                shippingCity: null,
                shippingPostCode: null,
                shippingCountry: null,
                shippingTel: null,
                shippingState: null,
                shippingEmail: null,
                shippingTitle: null,
                shippingIsFittingStation: false,
                fittingStationId: null,
                shippingLatitude: null,
                shippingLongitude: null,
                shippingAuthorityToLeave: null,
                shippingLeaveOptions: null,
                shippingLeaveComment: null
            },
            options: {
                optionsAddress: 'same'
            },
            isTest: false
        }
    };
}

export default getCartDefaultState;
